import { apiGet } from '../services/apiClient';

const buildQuery = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') qs.set(key, value);
  });
  const str = qs.toString();
  return str ? `?${str}` : '';
};

export const getLedgerSummary = (token, params = {}) =>
  apiGet(`/api/admin/finance/ledger/summary${buildQuery(params)}`, token);

export const listLedgerAccounts = (token, params = {}) =>
  apiGet(`/api/admin/finance/ledger/accounts${buildQuery(params)}`, token);

export const listLedgerEntries = (token, params = {}) =>
  apiGet(`/api/admin/finance/ledger/entries${buildQuery(params)}`, token);

export const exportLedgerEntriesCsv = async (token, params = {}) => {
  const qs = buildQuery(params);
  const baseUrl = process.env.REACT_APP_API_BASE_URL || '';
  const res = await fetch(`${baseUrl}/api/admin/finance/ledger/entries/export${qs}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    credentials: 'include',
  });
  if (!res.ok) {
    const text = await res.text();
    let msg = text;
    try {
      const data = JSON.parse(text);
      msg = data.message || text;
    } catch (_) {
      // ignore
    }
    throw new Error(msg || 'Failed to export ledger entries');
  }
  return res.blob();
};


